export default __webpack_public_path__ + "static/media/logoWhite.c945b895.png";